import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  jsonLd?: string;
}

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/**
 * 轻量站内 SEO 工具：设置 title、description、keywords、canonical、OG/Twitter 与 JSON-LD。
 * 不使用 react-helmet-async（已禁用），改为在页面渲染后直接更新 head。
 */
export function useSeo(options: SeoOptions) {
  useEffect(() => {
    const { title, description, keywords = "", path = "/", jsonLd } = options;
    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow");
    const url = `${window.location.origin}${path}`;
    let canon = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);
    setMeta("property", "og:url", url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "zh_CN");
    setMeta("property", "og:site_name", "导航爆料");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    const id = "page-jsonld";
    let old = document.getElementById(id) as HTMLScriptElement | null;
    if (jsonLd) {
      if (!old) {
        old = document.createElement("script");
        old.type = "application/ld+json";
        old.id = id;
        document.head.appendChild(old);
      }
      old.textContent = jsonLd;
    } else if (old) {
      old.remove();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}